import React from 'react';

function ThirdPage() {
  return (
    <h1>Page 3</h1>
  );
};

export default ThirdPage;
